<template>
  <div class="main-container" :style="{ height: screenHeight + 'px' }">
    <el-container>
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div class="information">
            <div class="box-shadow-border information-box">
              <h2>个人用户</h2>
              <div>{{ user.new }} <span class="add">(今日新增)</span></div>
              <div class="jinrixin"></div>
              <div style="font-size: 14px">
                <span>今日在线 {{ user.today }}</span>
                <span style="float: right">总数 {{ user.all }}</span>
              </div>
            </div>
            <div class="box-shadow-border information-box">
              <h2>下级代理商</h2>
              <div>{{ agent.today }} <span class="add">(今日新增)</span></div>
              <div class="jinrixin"></div>
              <div style="font-size: 14px">
                <span>总数 {{ agent.all }}</span>
              </div>
            </div>
            <div class="box-shadow-border information-box">
              <h2>通信助手</h2>
              <div>
                {{ call.today_seat_inc }} <span class="add">(今日呼叫)</span>
              </div>
              <div class="jinrixin"></div>
              <div style="font-size: 14px">
                <span> 今日接通 {{ call.pass }} </span>
                <span style="float: right">今日未接通 {{ call.miss }}</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="19" :sm="19" :md="19" :lg="19" :xl="19">
          <el-row class="shortcut">
            <el-col class="box-shadow-border">
              <h3 class="flags">
                <el-button-group>
                  <el-button
                    :type="time == 1 ? 'primary' : ''"
                    size="mini"
                    @click="qitian(1)"
                    >时</el-button
                  >
                  <el-button
                    :type="time == 2 ? 'primary' : ''"
                    size="mini"
                    @click="qitian(2)"
                    >天</el-button
                  >
                </el-button-group>
              </h3>
              <Online :echatsmsg="echatsmsg"> </Online>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
          <el-row class="progress">
            <el-col class="box-shadow-border">
              <h4>系统状态</h4>
              <div v-if="serve.cpu">
                <div class="progress-box">
                  <el-progress
                    type="circle"
                    :width="80"
                    :stroke-width="11"
                    :color="cpucolors"
                    :percentage="serve.cpu"
                  ></el-progress>
                  <div class="progress-title">
                    <span>CPU使用率</span>
                  </div>
                </div>
                <div class="progress-box">
                  <el-progress
                    type="circle"
                    :width="80"
                    :stroke-width="11"
                    :color="memcolors"
                    :percentage="serve.mem"
                  ></el-progress>
                  <div class="progress-title">
                    <span>内存使用率</span>
                  </div>
                </div>
                <div class="progress-box">
                  <el-progress
                    type="circle"
                    :width="80"
                    :stroke-width="11"
                    :color="percolors"
                    :percentage="serve.disk.per"
                  ></el-progress>
                  <div class="progress-title">
                    <span>硬盘使用率</span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <div class="ehcats-graph">
          <el-col :span="24" class="box-shadow-border">
            <el-row style="padding: 10px">
              <el-col :span="16">
                <el-button-group
                  style="position: absolute; z-index: 2; left: 100px"
                >
                  <el-button
                    :type="cockType == 1 ? 'primary' : ''"
                    size="mini"
                    @click="changeCockType(1)"
                    >ip地址</el-button
                  >
                  <el-button
                    :type="cockType == 2 ? 'primary' : ''"
                    size="mini"
                    @click="changeCockType(2)"
                    >经纬度</el-button
                  >
                </el-button-group>
                <Echarts
                  :userLoginAddress="userLoginAddress"
                  v-if="userLoginAddress.length"
                ></Echarts>
              </el-col>
              <el-col :span="8" style="padding: 20px" id="table-a">
                <h3 class="header-table">实时在线坐席分布</h3>
                <el-table
                  :data="userLoginAddress"
                  style="width: 100%"
                  :show-header="false"
                  max-height="400px"
                >
                  <el-table-column prop="province" label=""> </el-table-column>
                  <el-table-column prop="num" label=""> </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-col>
        </div>
      </el-row>
    </el-container>
  </div>
</template>

<script>
import { getData } from "@/api";
import Echarts from "./components/echats/index";
import Online from "./components/shortcut/Online";
export default {
  components: {
    Echarts,
    Online,
  },
  data() {
    return {
      screenHeight: document.body.clientHeight - 98,
      primary: true,
      zhanshi: "800px",
      echatsmsg: [1],
      cockType: 1,
      time: 1,
      agent: {},
      user: {},
      call: {},
      online: {},
      serve: {
        cpu: 0,
        disk: {
          per: 0,
        },
        mem: 0,
      },
      cpucolors: [
        { color: "#306DED", percentage: 20 },
        { color: "#306DED", percentage: 40 },
        { color: "#306DED", percentage: 60 },
        { color: "#306DED", percentage: 80 },
        { color: "#ff0000", percentage: 100 },
      ],
      percolors: [
        { color: "#42D19F", percentage: 20 },
        { color: "#42D19F", percentage: 40 },
        { color: "#42D19F", percentage: 60 },
        { color: "#42D19F", percentage: 80 },
        { color: "#ff0000", percentage: 100 },
      ],
      memcolors: [
        { color: "#EF9553", percentage: 20 },
        { color: "#EF9553", percentage: 40 },
        { color: "#EF9553", percentage: 60 },
        { color: "#EF9553", percentage: 80 },
        { color: "#ff0000", percentage: 100 },
      ],
      userLoginAddress: [],
    };
  },
  created() {
    this.qitian(1);
    this.getCommonData();
    this.changeCockType(this.cockType);
    this.getServe();
    window.addEventListener("resize", () => {
      window.screenHeight = document.body.clientHeight - 98;
      this.screenHeight = window.screenHeight;
    });
  },
  methods: {
    getCommonData() {
      getData("UserController/homeAction", {
        cockType: this.cockType,
      }).then((res) => {
        let { user, agent, call } = res.data;
        this.user = user;
        this.agent = agent;
        this.call = call;
      });
    },
    changeCockType(val) {
      this.cockType = val;
      this.userLoginAddress = [];
      getData("UserController/homeAction", {
        cockType: this.cockType,
      }).then((res) => {
        let { userLoginAddress } = res.data;
        this.userLoginAddress = userLoginAddress;
      });
    },
    qitian(val) {
      this.time = val;
      getData("UserController/homeAction").then((res) => {
        let { online } = res.data;
        this.online = online;
        if (this.time == 1) {
          this.echatsmsg = this.online.hour;
        } else if (this.time == 2) {
          this.echatsmsg = this.online.day;
        }
      });
    },
    getServe() {
      getData("CommonController/serverInfoAction").then((res) => {
        this.serve.cpu = Number(res.data.cpu);
        this.serve.disk.per = Number(res.data.disk.per);
        this.serve.disk.remain = Number(res.data.disk.remain);
        this.serve.mem = Number(res.data.mem);
      });
    },
  },

  watch: {
    $route(to) {
      if (to.name == "main") {
        this.qitian(1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main-container {
  margin: -15px;
  padding: none;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #f2f2f2;
}
.el-main {
  padding: 10px;
  background-color: #f2f2f2;
}
#table-a {
  .el-table--scrollable-y .el-table__body-wrapper {
    overflow: hidden;
  }
  .el-table::before {
    height: 0;
  }
}
#form-a {
  margin-top: 10px;
  .el-form-item__label {
    line-height: 30px;
  }
  .el-form-item__content {
    line-height: 30px;
  }
}

::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.box-shadow-border {
  box-shadow: 0px 0px 5px #dedede;
  background-color: #fff;
}
.el-container {
  height: 100%;
  background-color: #f2f2f2;
}
.el-row {
  width: 100%;
  height: 100%;
}
.information {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  overflow: hidden;
  .information-box {
    width: 30.6%;
    border-radius: 4px 4px 4px 4px;
    flex-shrink: 0;
    color: #333333;
    background-color: #fff;
    padding: 0.9%;
    h2 {
      font-size: 16px;
      font-weight: normal;
      color: #666666;
      line-height: 21px;
    }
    &:last-child {
      margin-right: 0;
    }
    .add {
      font-size: 14px;
      font-weight: normal;
      color: #999999;
    }
    div {
      font-size: 24px;
    }
    span {
      font-size: 14px;
      font-weight: normal;
      color: #666666;
    }
    h2 {
      margin: 0;
      font-size: 16px;
    }
  }
}
.ehcats-graph {
  box-sizing: border-box;
  float: left;
  width: 100%;
  padding: 0 15px;
  .el-col {
    div {
      height: 485px;
      // background-color: #256777;
    }
  }
}
.shortcut {
  padding: 5px 15px;
  margin-bottom: 15px;
  .el-col {
    position: relative;
    padding: 15px;
    .flags {
      div {
        height: 30px;
      }
      position: absolute;
      z-index: 2;
      left: 152px;
      top: -5px;
    }
    div {
      height: 350px;
    }
  }
}
.mb-10 {
  margin-bottom: 10px;
}

.header-table {
  text-align: center;
  font-size: 22px;
  font-weight: 500;
  background-color: #addeff;
  color: #26a7ff;
  margin: 0 !important ;
  padding: 5px;
}
.jinrixin {
  height: 80px;
  display: flex;
  align-items: center;
  img {
    width: 100%;
  }
}

.progress {
  padding: 5px 15px 5px 10px;
  .box-shadow-border {
    height: 380px;
    box-shadow: 0px 0px 5px #dedede;
    padding: 15px;
    background-color: #fff;
  }
  span {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 19px;
  }
  .progress-box {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .progress-title {
      height: 70px;
      line-height: 70px;
      margin-left: 15px;
      display: inline-block;
    }
  }
}
h4 {
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-weight: bold;
}
</style>
